import React, { useCallback, useEffect, useRef, useState, useMemo } from "react";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { apiErrorMessage } from "../../helper/apiError";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Divider,
  FormGroup,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Switch,
  TextField,
  Tooltip,
  Typography,
  createSvgIcon,
  styled,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import dayjs from "dayjs";
import RemoveIcon from "@mui/icons-material/Remove";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Calendar from "../../Icon/Calendar";
import CustomButton from "../../component/button/button";
import Previews from "../../component/dropzone/Mydropzone";
import MyLogoDropzone from "../../component/dropzone/LogoDropzone";
import CustomOutlinedSelect from "../../component/select field/OutlinedSelectField";
import CustomDataTable from "../../component/datatable/DataTable";
import Mylogodropzone from "../../component/dropzone/Mylogodropzone";
import CustomSelect from "../../component/select field/OutlinedSelectField";
import Setting from "../../Icon/Setting";
import OutlineCustomButton from "../../component/button/outlineButton";
import Settinglist from "../../Icon/Settinglist";
import { useDispatch, useSelector } from "react-redux";
import Message from "../../Icon/Message";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { useNavigate } from "react-router-dom";
import {
  GetAgentTransactionListAction,
  GetStudentAction,
  GetStudentChatByIdAction,
  GetStudentNotesByIdAction,
  GetStudentReminderByIdAction,
  GetUnsettledListAction,
} from "../../Redux/action/ApplicationAction";
import Msg from "../../Icon/Msg";
import StudentChat from "../../Icon/StudentChat";
import moment from "moment";
import {
  DeleteStudentNotesService,
  DeleteStudentReminderService,
  exportForOrganisactionByStudentIdAPI,
  getUncreditedUnsettledTransactionsForSelectedStudentsAPI,
  UpdateStudentTransactionService,
  exportForOrganisationByFilterAPI,
  getOrganisationInvoiceByFilterAPI,
} from "../../Redux/service/Application";
import ConfirmationModal from "../../component/Modal/ConfirmationModal/ConfirmationModal";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { HistoryOutlined } from "@ant-design/icons";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import GlobalSearch from "../../component/sidebar/globalSearch";
import { useListFilters } from "../../helper/useListFilters";
import { OrganisationExportModal } from "../../component/payoutsection/OrganisationExportModal.component";
import { PayoutAllReminderModal } from "../../component/payoutsection/AllReminder.component";
import PayoutWorkflowModal, {
  stepHint,
} from "../../component/payoutsection/PayoutWorkflowModal.component";
import {
  GetOrganizationAction,
  GetUniversityAction,
} from "../../Redux/action/SettingAction";
import axios from "axios";
import { basicurl, token } from "../../Redux/ServiceUrl/url";
import FilterComponent from "../../component/filterForTable/FilterComponent";
import { DefaultCommissionModal } from "../../component/payoutsection/DefaultCommissionModal";
import ExcelJS from "exceljs";
import { EditUniversityAmountModal } from "../../component/payoutsection/EditUniversityAmount";
import { FilterExcelUniversity } from "../../component/payoutsection/FilterExcel";
import { UpdateBulkIsCredited } from "../../component/payoutsection/UpdateBulkIsCredited";
import { UpdateBulkIsSettled } from "../../component/payoutsection/UpdateBulkIsSettled";
import * as excelJs from "exceljs";
import { CustomPagination } from "../../component/datatable/CustomPagination";

const PayoutlistPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formikRef = useRef(null);

  const currentRoleType = window.sessionStorage.getItem("user_role_type");
  const isAgent = currentRoleType === "agent";

  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  };

  const [confirmationopen, setConfirmationOpen] = useState(false);

  const [unsettledListlist, setunsettledListlist] = useState([]);

  const [table_load, setTable_load] = useState(false);

  const [HistoryModal, setHistoryModal] = useState(false);

  const [isFilterOpen, setFilterOpen] = useState(false);

  const [edit, setEdit] = useState(false);

  const [stdId, setStdId] = useState("");

  const [transactionId, settransactionId] = useState({});

  const [AgentTransactionlist, setAgentTransactionlist] = useState([]);

  const [noteId, setNoteId] = useState();

  const [reminderId, setReminderId] = useState();

  const [TypeOfdelete, setTypeOfdelete] = useState("");

  const [selectionModel, setSelectionModel] = useState([]);
  const [workflowHelpOpen, setWorkflowHelpOpen] = useState(false);
  const [orgExportOpen, setOrgExportOpen] = useState(false);
  const [orgExportLoading, setOrgExportLoading] = useState(false);
  const [invoiceExportOpen, setInvoiceExportOpen] = useState(false);
  const [invoiceExportLoading, setInvoiceExportLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [agentId, setAgentId] = useState(0);

  const [Universitylist, setUniversitylist] = useState([]);

  const [Organizationlist, setOrganizationlist] = useState([]);

  const [isToggled, setIsToggled] = useState(false);

  const [defaultCommisionModal, setDefaultCommisionModal] = useState(false);

  const [FilterExcelModal, setFilterExcelModal] = useState(false);

  const [BulkIsSetteledModal, setBulkIsSetteledModal] = useState(false);

  const [BulkIsCreditedModal, setBulkIsCreditedModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const AgentTransactionlistState = useSelector(
    (state) => state.application?.agenttransaction?.data?.agentTransactions
  );

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //(AgentTransactionlistState, "caht by id data");

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 5,
    hasNextPage: false,
    hasPrevPage: false,
  });

  const handlePageChange = (page) => {
    loadRows(activeFilters, { page, limit: pagination.limit });
  };

  const [limit, setLimit] = useState(25);

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    loadRows(activeFilters, { page: 1, limit: newLimit });
  };

  useEffect(() => {
    const updatedData = AgentTransactionlistState?.map(({ _id, ...rest }) => ({
      id: _id,
      ...rest,
    }));
    setAgentTransactionlist(updatedData);
    setTable_load(false);
  }, [AgentTransactionlistState]);

  const columns = [
    {
      field: "history",
      headerName: "Transaction history",
      width: 150,
      renderCell: (params) => {
        const handleHistoryActionClick = (e) => {
          e.stopPropagation();
          setStdId(params.row.id);
          setHistoryModal(true);
          setTable_load(true);
          //(params);
          setAgentId(params.row?.agent?._id);
          dispatch(
            GetAgentTransactionListAction(
              params.row?.organizationId?._id,
              params.row.id
            )
          );
        };
        return (
          <Box className="">
            <IconButton onClick={handleHistoryActionClick}>
              <HistoryOutlined />
            </IconButton>
          </Box>
        );
      },
    },

    {
      field: "studentFirstName",
      headerName: "Student Name",
      width: 250,
      renderCell: (params) => {
        return (
          <Box className="d-flex align-items-center h-100">
            <Typography align="" fontSize={fontSize.h3.medium}>
              <div className="text-center" style={{}}>
                {" "}
                {params.row?.studentFirstName +
                  " " +
                  params.row?.studentLastName}
              </div>
              <div style={{ color: ThemeColor.RED }}>
                {params.row?.isDuplicate ? (
                  <div
                    className="px-4 py-1"
                    style={{
                      backgroundColor: "rgba(221, 32, 37, 0.2)",
                      fontSize: "10px",
                      colo: "red",
                      borderRadius: "15px",
                    }}
                  >
                    Duplicate
                  </div>
                ) : (
                  ""
                )}
              </div>
              {/* A not-approved commission zeroes every remaining instalment
                  and settles them, so the student drops into the Settled view
                  looking like any other finished payout. The flag says why
                  they are there. */}
              {params.row?.commissionStatus === "not_approved" ? (
                <Tooltip
                  title={
                    params.row?.commissionStatusNotes ||
                    "The university did not approve this commission, so every instalment was closed at zero."
                  }
                >
                  <div
                    className="px-3 py-1 mt-1 d-inline-block"
                    style={{
                      backgroundColor: "rgba(221, 32, 37, 0.15)",
                      color: ThemeColor.RED,
                      fontSize: "10px",
                      fontWeight: 600,
                      borderRadius: "15px",
                      letterSpacing: "0.02em",
                      cursor: "help",
                    }}
                  >
                    NOT APPROVED
                  </div>
                </Tooltip>
              ) : (
                ""
              )}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "org",
      headerName: "Organization Name",
      width: 250,
      renderCell: (params) => {
        return (
          <div
            className="d-flex align-items-center h-100"
            style={{ textTransform: "lowercase" }}
          >
            <Typography align="" fontSize={fontSize.h3.medium}>
              {params.row?.organizationId?.organizationName}
            </Typography>
          </div>
        );
      },
    },
    {
      field: "university",
      headerName: "University",
      width: 250,
      renderCell: (params) => {
        return (
          <div
            style={{ textDecoration: "underline", textTransform: "lowercase" }}
          >
            {params.row?.university?.name}
          </div>
        );
      },
    },
    {
      field: "universityId",
      headerName: "Student Id/University Id",
      width: 200,
    },
    {
      field: "program.program",
      headerName: "Program",
      width: 250,
      renderCell: (params) => {
        return <div>{params.row.program?.program}</div>;
      },
    },
    {
      field: "degreeType.name",
      headerName: "Degree",
      width: 150,
      renderCell: (params) => {
        return <div>{params.row.degreeType?.name}</div>;
      },
    },

    {
      field: "intake",
      headerName: "intake",
      width: 150,
    },
    {
      field: "visaStatus",
      headerName: "Visa Status",
      width: 150,
      renderCell: (params) => {
        return (
          <Box className="d-flex align-items-center h-100">
            <Typography align="" fontSize={fontSize.h3.medium}>
              {params.row?.visaStatus?.split("_")?.join(" ")}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "visaApprovedDate",
      headerName: "Visa Approved",
      width: 150,
      renderCell: (params) => (
        <Box className="d-flex align-items-center h-100">
          <Typography fontSize={fontSize.h3.medium}>
            {params.row?.visaApprovedDate &&
            dayjs(params.row.visaApprovedDate).isValid()
              ? dayjs(params.row.visaApprovedDate).format("DD MMM YYYY")
              : "-"}
          </Typography>
        </Box>
      ),
    },
    {
      field: "paymentSummary",
      headerName: "Payments",
      width: 150,
      // How much of the payout is done: instalments are created one per payment
      // cycle when the visa is approved, so "2/4" means two settled, two to go.
      sortComparator: (a, b) => (a?.settled ?? 0) - (b?.settled ?? 0),
      renderCell: (params) => {
        const summary = params.row?.paymentSummary;
        if (!summary || !summary.total) {
          return (
            <Box className="d-flex align-items-center h-100">
              <Typography fontSize={fontSize.h3.medium} color={ThemeColor.GREY}>
                -
              </Typography>
            </Box>
          );
        }

        const done = summary.settled >= summary.total;

        return (
          <Box className="d-flex align-items-center h-100">
            <Tooltip
              title={`${summary.settled} of ${summary.total} instalments settled · ${summary.remaining} remaining`}
            >
              <Chip
                size="small"
                label={summary.progress}
                sx={{
                  fontWeight: 700,
                  borderRadius: "6px",
                  bgcolor: done ? "#DCFCE7" : "#EFF6FF",
                  color: done ? "#15803D" : "#1D4ED8",
                }}
              />
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "commissionStatus",
      headerName: "Commission Status",
      width: 180,
      renderCell: (params) => {
        return (
          <Box className="d-flex align-items-center h-100">
            {" "}
            <Typography align="" fontSize={fontSize.h3.medium}>
              {params.row?.commissionStatus?.split("_")?.join(" ")}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "commissionStatusNotes",
      headerName: "Commission Status Notes",
      width: 220,
      // renderCell: (params) => {
      //   return (
      //     <Box className="d-flex align-items-center h-100">
      //       {" "}
      //       <Typography align="" fontSize={fontSize.h3.medium}>
      //         {params.row?.commissionStatus?.split("_")?.join(" ")}
      //       </Typography>
      //     </Box>
      //   );
      // },
    },

    // {
    //   field: "end_date",
    //   headerName: "Entry Date",
    //   width: 150,
    //   renderCell: (params) => {
    //     return (
    //       <div>{dayjs(params.row.createdOn).format("YYYY-MM-DD HH:MM")}</div>
    //     );
    //   },
    // },
  ];

  const unsettledListState = useSelector(
    (state) => state.application?.unsettledList?.data
  );

  useEffect(() => {
    console.log(unsettledListState?.pagination);
    if (unsettledListState) {
      // const { data, pagination } = unsettledListState;
      // setRows(data);
      setPagination(unsettledListState?.pagination);
    }
  }, [unsettledListState]);
  //(unsettledListState, "Student data");

  useEffect(() => {
    setTable_load(true);
    // Through `loadRows` so that arriving back from a student's page - where
    // the filters are restored from the history entry - reloads the same
    // filtered view rather than the full list.
    loadRows(getFilters(), { isSettled: false, page: 1, limit: 25 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Rows for a filtered view do not come from redux. Letting this run would
    // write the stale unfiltered list back over them - which is why the filter
    // survived a reload (redux is empty then) but not an import.
    //
    // A later redux change means an action elsewhere refreshed the data (an
    // import, a bulk update, an amount edit - those modals dispatch the plain
    // list action themselves), so the filtered view is fetched again instead.
    if (getFilters().length > 0) {
      if (reduxSyncedOnce.current) loadRows(getFilters());
      reduxSyncedOnce.current = true;
      setTable_load(false);
      return;
    }
    reduxSyncedOnce.current = true;

    const updatedData = unsettledListState?.allStudents?.map(
      ({ _id, ...rest }) => ({
        id: _id,
        ...rest,
      })
    );
    setunsettledListlist(updatedData);
    setTable_load(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unsettledListState]);

  const handleDefaultCommissionModal = () => {
    setDefaultCommisionModal(!defaultCommisionModal);
  };

  // const handleExport = async () => {
  //   const selectedRows = unsettledListlist.filter((row) =>
  //     selectionModel.includes(row.id)
  //   );
  //   let agent2 = [{}];
  //   let agent = [];
  //   // console.log(selectedRows.map((data)=>data.id))

  //   let transactionList = [];
  //   let totals = [];
  //   let totalOrganisationCommission = "";
  //   let exchangeRate = "";
  //   let commission = {};

  //   await GetTransDetailForSelectedStdService({
  //     studentIds: selectedRows.map((data) => data.id),
  //   })
  //     .then((res) => {
  //       console.log(res);
  //       if (res.status === 200) {
  //         transactionList = res.data?.transactions;
  //         totals = res.data.totals;
  //         totalOrganisationCommission = res?.data?.totalOrganisationCommission;
  //         exchangeRate = res?.data?.commission?.exchangeRateUSDToINR;
  //         commission = res.data?.commission;

  //         const columns = [
  //           { header: "First Name", key: "studentId.studentFirstName" },
  //           { header: "Last Name", key: "studentId.studentLastName" },
  //           { header: "Student ID", key: "studentId.universityId" },
  //           { header: "Program", key: "studentId.program.program" },
  //           { header: "Degree", key: "studentId.degreeType.name" },

  //           {
  //             header: "Semester",
  //             key: "studentId.intake",
  //           },
  //           {
  //             header: "Payment",
  //             key: "currentTransactionNumber",
  //           },
  //           { header: "Amount in USD", key: "organisationCommission" },
  //         ];

  //         const columnsList2 = [
  //           { header: "Gross Commssion", key: "grossCommission" },
  //           { header: "Gst", key: "gstAmount" },
  //           // { header: "Invoice total amount", key: "studentId._id" },
  //           {
  //             header: "tds",
  //             key: "tdsAmount",
  //           },
  //           {
  //             header: "cheques payable",
  //             key: "chequePayable",
  //           },
  //         ];

  //         const transformedData = transactionList.map((item) => {
  //           const row = {};
  //           columns.forEach((col) => {
  //             row[col.header] =
  //               col.key.split(".").reduce((o, k) => (o || {})[k], item) || ""; // Handle nested keys
  //           });
  //           return row;
  //         });

  //         // const totalsRows = Object.keys(totals).map((key) => ({
  //         //   Key: key,
  //         //   Value: totals[key],
  //         // }));

  //         // console.log(totalsRows)

  //         const keyOrgAmt =
  //           transactionList.length > 1
  //             ? transactionList
  //                 .map((data) => data.organisationCommission)
  //                 .join("+")
  //             : `${transactionList[0]?.organisationCommission || 0}`;

  //         const keyInvoiceAmt = `${totalOrganisationCommission}*${exchangeRate}`;

  //         // const keyGrossAMt = `(${totals.invoiceTotalAmount}/118)*100=${totals.grossCommission}`;
  //         const keyGrossAMt = `=${totals.grossCommission}`;

  //         // const keyGstAmt = `(${totals.grossCommission}*${commission.gstPercentage})/100=${totals.gstAmount}`;
  //         const keyGstAmt = `=${totals.gstAmount}`;

  //         // const keyTdsAmt = `(${totals.grossCommission}*${commission.tdsPercentage})/100=${totals.tdsAmount}`;
  //         const keyTdsAmt = `=${totals.tdsAmount}`;

  //         const keyChequePayable = `${totals.invoiceTotalAmount}-${totals.tdsAmount}=${totals.chequePayable}`;

  //         const totalsRows = [
  //           {
  //             key: `Total Commision(in USD)`,
  //             value:
  //               transactionList.length > 1
  //                 ? `=${totalOrganisationCommission}`
  //                 : keyOrgAmt,
  //           },
  //           {
  //             key: "Invoice Total Amount(in INR)",
  //             value: `${keyInvoiceAmt}=${totals.invoiceTotalAmount}`,
  //           },
  //           { key: "Total Gross Amount(in INR)", value: keyGrossAMt },
  //           { key: "Total GST Amount(in INR)", value: keyGstAmt },
  //           { key: "Total TDS Amount(in INR)", value: keyTdsAmt },

  //           { key: "Total Cheque Payable(in INR)", value: keyChequePayable },
  //         ];

  //         // console.log(totalsRows);

  //         // Create a worksheet for the first dataset
  //         const worksheet = XLSX.utils.json_to_sheet(transformedData);

  //         if (transactionList.length > 0) {
  //           XLSX.utils.sheet_add_json(worksheet, totalsRows, {
  //             origin: { r: transformedData.length + 2, c: 0 }, // Append to the next empty row
  //             skipHeader: true, // Include headers for the totals data
  //           });
  //         }

  //         // Append the totals data as separate columns

  //         // Create a workbook and append the sheet
  //         const workbook = XLSX.utils.book_new();
  //         XLSX.utils.book_append_sheet(workbook, worksheet, "CombinedData");

  //         const excelBuffer = XLSX.write(workbook, {
  //           bookType: "xlsx",
  //           type: "array",
  //         });

  //         const dataBlob = new Blob([excelBuffer], {
  //           type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  //         });

  //         saveAs(dataBlob, `OrganizationInvoice.xlsx`);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err, "err of get trans detail for selected std");
  //       dispatch(showSnackbar(apiErrorMessage(err), "error"));
  //     });

  //   // selectedRows.map((data) => {
  //   //   //(data);
  //   //   if (agent.length === 0 || !agent.some((item) => item === data.organizationId._id))
  //   //     agent.push(data.organizationId._id);
  //   // });
  //   //(agent);

  //   // const array = [];

  //   // agent.map((type) => {
  //   //   //(type);
  //   //   array.push(selectedRows.filter((data) => data.organizationId._id === type));
  //   // });

  //   // array.map((data) => {
  //   //   const worksheet = XLSX.utils.json_to_sheet(data);
  //   //   const workbook = XLSX.utils.book_new();
  //   //   XLSX.utils.book_append_sheet(workbook, worksheet, "SelectedData");
  //   //   const excelBuffer = XLSX.write(workbook, {
  //   //     bookType: "xlsx",
  //   //     type: "array",
  //   //   });
  //   //   const dataBlob = new Blob([excelBuffer], {
  //   //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  //   //   });
  //   //   saveAs(dataBlob, `${data[0].organizationId.organizationName}.xlsx`);
  //   // });
  // };

  /**
   * Intakes offered in the organisation export modal.
   *
   * There is no stored list of intakes, so this covers the seasons around the
   * current year. The server matches case- and separator-insensitively, so
   * "Fall 2026" finds rows stored as "fall 2026".
   */
  const intakeOptions = useMemo(() => {
    const thisYear = moment().year();
    const options = [];
    for (let year = thisYear - 1; year <= thisYear + 2; year += 1) {
      ["Spring", "Summer", "Fall"].forEach((season) => {
        options.push(`${season} ${year}`);
      });
    }
    return options;
  }, []);

  /** Export every student an organisation has for an intake. */
  const handleOrganisationExport = async ({
    organizationId,
    university,
    intake,
    approvedOnly,
  }) => {
    setOrgExportLoading(true);
    try {
      const res = await exportForOrganisationByFilterAPI({
        organizationId,
        university,
        intake,
        approvedOnly,
      });

      const transactions = res?.data?.transactions || [];
      if (transactions.length === 0) {
        // The server words this differently when the approved-only tick is
        // on, so prefer what it said over a guess made here.
        dispatch(
          showSnackbar(
            res?.data?.message ||
              "No students found for that organisation and intake",
            "warning"
          )
        );
        return;
      }

      // By default nothing is filtered out: the report is meant to show what
      // happened with every student, refused commissions included. Ticking
      // "only commission approved" narrows it to a settlement list.
      const orgName =
        transactions[0]?.studentId?.organizationId?.organizationName ||
        "Organisation";
      const uniName =
        (Universitylist || []).find((uni) => uni._id === university)?.title ||
        "";

      await buildTransactionSheet(
        transactions,
        "Organisation-Transaction",
        [
          orgName,
          uniName,
          intake,
          approvedOnly ? "Approved Only" : "Student Report",
        ]
          .filter(Boolean)
          .join(" - ")
      );

      setOrgExportOpen(false);
      refresh();
    } catch (error) {
      dispatch(showSnackbar(apiErrorMessage(error), "error"));
    } finally {
      setOrgExportLoading(false);
    }
  };

  /**
   * Builds and downloads the transactions sheet.
   *
   * Lifted out of `handleExportForUniv` so the organisation report, which
   * fetches by organisation and intake rather than by ticked rows, produces
   * exactly the same sheet.
   */
  const buildTransactionSheet = async (transactionList, name, fileName) => {
    // Create a new workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Transactions");

    // Define columns
    const columns = [
      { header: "CAE ID", key: "uniqueCaeId", width: 20 },
      { header: "First Name", key: "studentFirstName", width: 20 },
      { header: "Last Name", key: "studentLastName", width: 20 },
      { header: "Date of Birth", key: "dateOfBirth", width: 15 },
      { header: "Student ID", key: "universityId", width: 15 },
      { header: "Program", key: "program", width: 20 },
      { header: "Degree", key: "degree", width: 20 },
      { header: "Semester", key: "intake", width: 15 },
      { header: "Payment", key: "currentTransactionNumber", width: 15 },
      ...(name !== "Organisation-Transaction"
        ? [
          {
            header: "University Amount",
            key: "receivedFromUniversity",
            width: 20,
          },
        ]
        : [
          { header: "Organisation Name", key: "organisation", width: 24 },
          // An organisation's report spans every university it sends to, so
          // the sheet has to say which one each row is about.
          { header: "University", key: "university", width: 28 },
        ]),
      { header: "Commission Status", key: "commissionStatus", width: 20 },
      {
        header: "Commission Status Notes",
        key: "commissionStatusNotes",
        width: 25,
      },

      { header: "Credited", key: "isCredited", width: 10 },
      { header: "Settled", key: "isSettled", width: 10 },
      { header: "Notes", key: "notes", width: 30 },
    ];

    // Assign columns to the worksheet
    worksheet.columns = columns;

    // Populate data
    transactionList.forEach((item) => {
      const rowData = {
        uniqueCaeId: item?.studentId?.uniqueCaeId || "",
        studentFirstName: item?.studentId?.studentFirstName || "",
        studentLastName: item?.studentId?.studentLastName || "",
        dateOfBirth:
          dayjs(item?.studentId?.dateOfBirth).format("DD/MM/YYYY") || "",
        universityId: item?.studentId?.universityId || "",
        program: item?.studentId?.program?.program || "",
        degree: item?.studentId?.degreeType?.name || "",
        intake: item?.studentId?.intake || "",
        // A settled instalment has nothing outstanding, so the payment it
        // was numbered no longer means anything to the reader - 0 says
        // "nothing is due" where "3" reads like a third payment is coming.
        currentTransactionNumber: item?.isSettled
          ? 0
          : item?.currentTransactionNumber || "",
        receivedFromUniversity: item?.receivedFromUniversity || "",
        organisation: item?.studentId?.organizationId?.organizationName || "",
        university:
          item?.studentId?.university?.name ||
          item?.studentId?.university?.title ||
          "",
        commissionStatus: item?.studentId?.commissionStatus || "",
        commissionStatusNotes: item?.studentId?.commissionStatusNotes || "",
        isCredited: item?.isCredited ? "Yes" : "No",
        isSettled: item?.isSettled ? "Yes" : "No",
        notes: item?.notes || "",
      };

      worksheet.addRow(rowData);
    });

    worksheet.getRow(1).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFADD8E6" },
    };

    // Apply data validation for "Commission Status" dropdown
    const lastRow = worksheet.rowCount; // Get last row number
    const commissionStatusOptions = ["pending", "approved", "deffered", "not_approved"];
    const isCreditedOptions = ["Yes", "No"];



    // for (let i = 2; i <= lastRow; i++) {
    //   worksheet.getCell(`J${i}`).dataValidation = {
    //     type: "list",
    //     allowBlank: false,
    //     formulae: [`"${commissionStatusOptions.join(",")}"`], // Dropdown list
    //   };
    // }

    worksheet.getColumn("commissionStatus").eachCell((cell, rowNumber) => {
      if (rowNumber !== 1) {
        cell.dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [`"${commissionStatusOptions.join(",")}"`],
          showErrorMessage: true,
          errorTitle: "Invalid Status",
          error: "Please select a valid commission status.",
        };
      }
    });

    worksheet.getColumn("isCredited").eachCell((cell, rowNumber) => {
      if (rowNumber !== 1) {
        cell.dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [`"${isCreditedOptions.join(",")}"`],
          showErrorMessage: true,
          errorTitle: "Invalid Status",
          error: "Please select a valid option.",
        };
      }
    });
    worksheet.getColumn("isSettled").eachCell((cell, rowNumber) => {
      if (rowNumber !== 1) {
        cell.dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [`"${isCreditedOptions.join(",")}"`],
          showErrorMessage: true,
          errorTitle: "Invalid Status",
          error: "Please select a valid option.",
        };
      }
    });

    // Write Excel file and trigger download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `${fileName || name}.xlsx`);
  };

  const handleExportForUniv = async (univ, name) => {
    console.log(name);
    const selectedRows = unsettledListlist.filter((row) =>
      selectionModel.includes(row.id)
    );

    let transactionList = [];

    if (name === "Organisation-Transaction") {
      console.log("name for org");
      await exportForOrganisactionByStudentIdAPI({
        studentIds: selectedRows.map((data) => data.id),
      })
        .then((res) => {
          if (res.status === 200) {
            transactionList = res.data?.transactions.filter(
              (data) => data.commissionStatus !== "not_approved"
            );
            console.log(transactionList);
          }
        })
        .catch((err) => {
          console.log(err, "Error fetching transaction details");
        });
    } else {
      console.log("for invoice", name);
      const isListExport = name === "University-Transaction";
      const isInvoiceExport = name === "University-Invoice";
      await getUncreditedUnsettledTransactionsForSelectedStudentsAPI(
        { studentIds: selectedRows.map((data) => data.id) },
        isListExport,
        isInvoiceExport
      )
        .then((res) => {
          if (res.status === 200) {
            if (name === "University-Invoice") {
              // Only an approved commission can be billed. This used to
              // exclude "pending" alone, so deferred and refused ones still
              // reached the sheet. The server now filters too; this stays as
              // the guard for anything already in flight.
              transactionList = (res.data?.transactions || []).filter(
                (data) => data?.studentId?.commissionStatus === "approved"
              );
            } else {
              transactionList = res.data?.transactions;
              console.log(transactionList);
            }
          }
        })
        .catch((err) => {
          console.log(err, "Error fetching transaction details");
        });
    }

    await buildTransactionSheet(transactionList, name);
  };

  /**
   * The payout invoice. Chosen by organisation, university and intake rather
   * than by ticking rows, the same way the status report is.
   */
  async function handleExport({ organizationId, university, intake }) {
    setInvoiceExportLoading(true);
    let res;
    try {
      res = await getOrganisationInvoiceByFilterAPI({
        organizationId,
        university,
        intake,
      });
    } catch (error) {
      dispatch(showSnackbar(apiErrorMessage(error), "error"));
      setInvoiceExportLoading(false);
      return;
    }
    setInvoiceExportLoading(false);

    if (res.status === 200 && !(res.data?.transactions || []).length) {
      dispatch(
        showSnackbar(
          res.data?.message ||
            "Nothing to invoice for that organisation and intake",
          "warning"
        )
      );
      return;
    }

    if (res.status === 200) {
      setInvoiceExportOpen(false);
      const organizationNames = res.data?.organizationNames || "Organization Name";
      const transactionList = res.data?.transactions || [];
      const totals = res.data?.totals || {};
      const totalOrganisationCommission =
        res?.data?.totalOrganisationCommission || 0;
      const exchangeRate = res?.data?.commission?.exchangeRateUSDToINR || 1;

      const gstPercentage = res?.data?.commission?.gstPercentage ?? 0;
      const tdsPercentage = res?.data?.commission?.tdsPercentage ?? 0;

      const columns = [
        { header: "First Name", key: "studentId.studentFirstName", width: 18 },
        { header: "Last Name", key: "studentId.studentLastName", width: 18 },
        { header: "Student ID", key: "studentId.universityId", width: 16 },
        { header: "Program", key: "studentId.program.program", width: 34 },
        { header: "Degree", key: "studentId.degreeType.name", width: 16 },
        // An organisation sends students to several universities, so the
        // invoice has to say which one each line is for.
        { header: "University", key: "studentId.university.name", width: 28 },
        { header: "Semester", key: "studentId.intake", width: 14 },
        { header: "Payment", key: "currentTransactionNumber", width: 11 },
        {
          header: "Amount in USD",
          key: "organisationCommission",
          width: 16,
          money: true,
        },
      ];

      const transformedData = transactionList.map((item) => {
        const row = {};
        columns.forEach((col) => {
          const value = col.key.split(".").reduce((o, k) => (o || {})[k], item);
          row[col.header] = value === undefined || value === null ? "" : value;
        });
        return row;
      });

      // GST is charged ON TOP of the commission now, so the running order is
      // gross -> add GST -> invoice total -> withhold TDS -> cheque payable.
      const totalsRows = [
        {
          key: "Total Commission (USD)",
          value: totalOrganisationCommission,
          format: "usd",
          working: "",
        },
        {
          key: "Exchange Rate (USD to INR)",
          value: exchangeRate,
          format: "rate",
          working: "",
        },
        {
          key: "Gross Commission (INR)",
          value: totals.grossCommission,
          format: "inr",
          working: totalOrganisationCommission + " x " + exchangeRate,
        },
        {
          key: "GST @ " + gstPercentage + "% (INR)",
          value: totals.gstAmount,
          format: "inr",
          working: totals.grossCommission + " x " + gstPercentage + "%  (added)",
        },
        {
          key: "Invoice Total (INR)",
          value: totals.invoiceTotalAmount,
          format: "inr",
          working: totals.grossCommission + " + " + totals.gstAmount,
          emphasise: true,
        },
        {
          key: "TDS @ " + tdsPercentage + "% (INR)",
          value: totals.tdsAmount ? -Math.abs(totals.tdsAmount) : 0,
          format: "inr",
          working:
            totals.grossCommission + " x " + tdsPercentage + "%  (withheld)",
        },
        {
          key: "Cheque Payable (INR)",
          value: totals.chequePayable,
          format: "inr",
          working: totals.invoiceTotalAmount + " - " + totals.tdsAmount,
          emphasise: true,
        },
      ];

      const PURPLE = "FF15539E";
      const LIGHT = "FFEFF6FF";
      const thin = { style: "thin", color: { argb: "FFCBD5E1" } };
      const boxed = { top: thin, left: thin, bottom: thin, right: thin };
      const INR = '"\u20b9"#,##0';
      const USD = '"$"#,##0.00';

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Invoice", {
        views: [{ state: "frozen", ySplit: 4 }],
      });

      worksheet.columns = columns.map((col) => ({
        key: col.header,
        width: col.width || 20,
      }));

      const lastCol = columns.length;

      // ---- title block ----
      const titleRow = worksheet.addRow([organizationNames]);
      worksheet.mergeCells(titleRow.number, 1, titleRow.number, lastCol);
      titleRow.height = 26;
      titleRow.getCell(1).font = {
        bold: true,
        size: 15,
        color: { argb: "FFFFFFFF" },
      };
      titleRow.getCell(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: PURPLE },
      };
      titleRow.getCell(1).alignment = {
        vertical: "middle",
        horizontal: "left",
        indent: 1,
      };

      const subtitleRow = worksheet.addRow([
        "Commission Invoice  -  " +
          transformedData.length +
          " student(s)  -  generated " +
          dayjs().format("DD MMM YYYY"),
      ]);
      worksheet.mergeCells(subtitleRow.number, 1, subtitleRow.number, lastCol);
      subtitleRow.getCell(1).font = { size: 10, color: { argb: "FF64748B" } };
      subtitleRow.getCell(1).alignment = { horizontal: "left", indent: 1 };

      worksheet.addRow([]);

      // ---- data table ----
      const headerRow = worksheet.addRow(columns.map((col) => col.header));
      headerRow.height = 20;
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: PURPLE },
        };
        cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11 };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = boxed;
      });

      transformedData.forEach((data, index) => {
        const row = worksheet.addRow(columns.map((col) => data[col.header]));
        row.eachCell((cell, colNumber) => {
          cell.border = boxed;
          if (index % 2 === 1) {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: LIGHT },
            };
          }
          if (columns[colNumber - 1] && columns[colNumber - 1].money) {
            cell.numFmt = USD;
            cell.alignment = { horizontal: "right" };
          }
        });
      });

      if (transformedData.length) {
        worksheet.autoFilter = {
          from: { row: headerRow.number, column: 1 },
          to: {
            row: headerRow.number + transformedData.length,
            column: lastCol,
          },
        };
      }

      // ---- calculation block ----
      worksheet.addRow([]);
      const calcTitle = worksheet.addRow(["Calculation For Invoice"]);
      worksheet.mergeCells(calcTitle.number, 1, calcTitle.number, 3);
      calcTitle.height = 20;
      calcTitle.getCell(1).font = {
        bold: true,
        size: 12,
        color: { argb: "FFFFFFFF" },
      };
      calcTitle.getCell(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: PURPLE },
      };
      calcTitle.getCell(1).alignment = { vertical: "middle", indent: 1 };

      const calcHead = worksheet.addRow([
        "Item",
        "Amount",
        "How it is worked out",
      ]);
      calcHead.eachCell((cell, colNumber) => {
        if (colNumber > 3) return;
        cell.font = { bold: true, size: 10, color: { argb: "FF475569" } };
        cell.border = boxed;
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: LIGHT },
        };
      });

      totalsRows.forEach((item) => {
        const row = worksheet.addRow([item.key, item.value, item.working]);
        [1, 2, 3].forEach((colNumber) => {
          const cell = row.getCell(colNumber);
          cell.border = boxed;
          if (item.emphasise) {
            cell.font = { bold: true };
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: LIGHT },
            };
          }
        });
        row.getCell(1).alignment = { indent: 1 };
        row.getCell(2).numFmt =
          item.format === "usd" ? USD : item.format === "rate" ? "#,##0.00" : INR;
        row.getCell(2).alignment = { horizontal: "right" };
        row.getCell(3).font = { size: 9, color: { argb: "FF94A3B8" } };
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(
        blob,
        (organizationNames || "Organisation") + " - Commission Invoice.xlsx"
      );
    }
  }

  const fetchData = async (filters) => {
    // encodeURIComponent: a university name with a space or an "&" used to
    // truncate the query string at that character.
    let string = filters
      .filter((data) => data.value !== undefined && data.value !== "")
      .map(
        (data) =>
          `${encodeURIComponent(data.field)}=${encodeURIComponent(data.value)}`
      );
    try {
      let response = await axios.get(
        basicurl +
        `/api/student/get-visa-approved-unsettled-student-list?${string.join(
          "&"
        )}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // const result = await response.json();
      console.log(response);

      setunsettledListlist(
        response?.data?.allStudents?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
      // setData(
      //   response.data.students?.map(({ _id, ...rest }) => ({
      //     id: _id,
      //     ...rest,
      //   }))
      // ); // Assuming the response structure has a `data` key
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  };

  /**
   * The one way this page loads rows.
   *
   * Everything that changes the table - applying a filter, searching, toggling
   * Settled, paging, closing a bulk-update modal - goes through here, so the
   * filter that is on screen is always the filter the rows were fetched with.
   */
  const loadRows = useCallback(
    (filters = [], over = {}) => {
      const settled = over.isSettled ?? isToggled;
      const page = over.page ?? 1;
      const rowLimit = over.limit ?? limit;
      const term = (over.search ?? searchTerm).trim();

      const narrowing = [
        ...(filters || []),
        ...(term ? [{ field: "search", value: term }] : []),
      ];

      if (narrowing.length === 0) {
        dispatch(
          GetUnsettledListAction(settled, { page, limit: rowLimit })
        );
        return;
      }

      fetchData([
        ...narrowing,
        { field: "isSettled", value: String(settled) },
        { field: "page", value: String(page) },
        { field: "limit", value: String(rowLimit) },
      ]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, isToggled, limit, searchTerm]
  );

  /** False until the first redux sync, so mounting does not fetch twice. */
  const reduxSyncedOnce = useRef(false);

  const { activeFilters, getFilters, applyFilters, refresh } = useListFilters(
    (filters) => loadRows(filters),
    () => loadRows([])
  );

  const handleApplyFilters = applyFilters;

  /** Search box: re-runs whatever filters are applied, with the new term. */
  const handlePayoutSearch = (value) => {
    const trimmed = String(value || "").trim();
    setSearchTerm(trimmed);
    loadRows(activeFilters, { search: trimmed });
  };

  const fields = [
    {
      label: "University Name",
      value: "university",
      type: "multi-select",
      option: Universitylist,
    },
    ...(!isAgent
      ? [
          {
            label: "Organization",
            value: "organisationId",
            type: "multi-select",
            option: Organizationlist,
          },
        ]
      : []),
    {
      label: "Intake",
      value: "intake",
      type: "text",
    },
    {
      label: "Commission Status",
      value: "commissionStatus",
      type: "multi-select",
      option: [
        { _id: "pending", title: "Pending" },
        { _id: "approved", title: "Approved" },
        { _id: "not_approved", title: "Not Approved" },
      ],
    },
    {
      label: "Is Settled",
      value: "isToggled",
      type: "multi-select",
      option: [
        { _id: true, title: "Yes" },
        { _id: false, title: "No" },
      ],
    },
  ];

  const UniversitylistState = useSelector(
    (state) => state.setting?.university?.data?.universities
  );
  const OrganizationlistState = useSelector(
    (state) => state.setting?.organization?.data
  );

  useEffect(() => {
    let data = {
      page: 1,
      limit: 0,
    };
    dispatch(GetUniversityAction(data));
    if (!isAgent) {
      dispatch(GetOrganizationAction(data));
    }
  }, [dispatch, isAgent]);

  const handleStatusChange = async () => {
    const newToggleState = !isToggled;
    setIsToggled(newToggleState);
    // Keep whatever is filtered; only the settled side changes.
    loadRows(activeFilters, { isSettled: newToggleState });
  };

  useEffect(() => {
    setUniversitylist(
      UniversitylistState?.map(({ name, ...rest }) => ({
        title: name,
        ...rest,
      }))
    );

    setOrganizationlist(
      OrganizationlistState?.organizations?.map(
        ({ organizationName, ...rest }) => ({
          title: organizationName,
          ...rest,
        })
      )
    );
  }, [UniversitylistState, OrganizationlistState]);

  const handleCloseHistoryModal = () => setHistoryModal(!HistoryModal);
  const handleCloseFilterExcelModal = () => {
    refresh();
    setFilterExcelModal(!FilterExcelModal);
  };

  const handleCloseIsCreditedModal = () => {
    refresh();
    setBulkIsCreditedModal(!BulkIsCreditedModal);
  };

  const handleCloseIsSettledModal = () => {
    refresh();
    setBulkIsSetteledModal(!BulkIsSetteledModal);
  };

  const checkYearOfIntake = (data) => {
    const currentYear = moment().year();
    const intakeYear = moment(data?.intake?.split(" ")?.[1], "YYYY").year();
    console.log(
      intakeYear >= currentYear - 2,
      data?.intake?.split(" ")?.[1],
      moment(data?.intake?.split(" ")?.[1], "YYYY").year()
    );

    return intakeYear >= currentYear - 2;
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Hide the loader after 2 seconds
    }, 2000); // Simulate 2 seconds of loading time
  }, []);

  return (
    <div>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            fontSize: "24px",
            color: "#007bff",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100px",
              height: "100px",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "transparent",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src="/assest/Group.png" // Your image URL
                alt="Loading..."
                style={{ width: "75%", height: "75%", objectFit: "contain" }}
              />
            </div>

            <CircularProgress
              size={100}
              sx={{
                color: ThemeColor.NAVYBLUE, // Customize the loader color
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1,
              }}
            />
          </div>
        </div>
      ) : (
        <>
          <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
            <Grid item xs={12} md={3}>
              <Box display="flex" alignItems="center" gap={0.5}>
                <Typography
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W600}
                  fontSize={fontSize.h2.small}
                  noWrap
                >
                  Payout List
                </Typography>
                {/* The seven export/import steps must run in order and each has
                    its own preconditions - more than a menu label can carry. */}
                <Tooltip title="How the payout workflow works">
                  <IconButton
                    size="small"
                    aria-label="How the payout workflow works"
                    onClick={() => setWorkflowHelpOpen(true)}
                    sx={{ color: ThemeColor.PURPLE }}
                  >
                    <InfoOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid>
            <Grid item xs={12} md={9}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: { xs: "flex-start", md: "flex-end" },
                  flexWrap: "wrap",
                  // One gap for the whole row. Each control used to carry its
                  // own px-2 wrapper on top of this, which doubled the spacing
                  // and pushed the row onto a second line.
                  gap: 1,
                  width: "100%",
                  // The shared button components do not forward `sx`, so the
                  // row sizes them from here. Keeps every control 40px tall.
                  "& .MuiButton-root": {
                    height: 40,
                    px: 2,
                    py: 0,
                    minWidth: 0,
                    fontSize: fontSize.h4.large,
                    borderWidth: "1px",
                    whiteSpace: "nowrap",
                  },
                }}
              >
                {/* Same debounced box as the Applicants section, so pasting a
                    full name works here too. It lives inside this component
                    because the list is local state, not redux. */}
                <Box sx={{ flexGrow: 1, flexBasis: 200, minWidth: 170, maxWidth: 300 }}>
                  <GlobalSearch
                    compact
                    placeholder={
                      isAgent
                        ? "Search student..."
                        : "Search student, organisation..."
                    }
                    onSearch={handlePayoutSearch}
                  />
                </Box>
                {!isAgent && (
                  <OutlineCustomButton
                    variant="contained"
                    type="submit"
                    backgroundColor={ThemeColor.PURPLE}
                    onClick={() =>
                      setDefaultCommisionModal(!defaultCommisionModal)
                    }
                  >
                    Commission Defaults
                  </OutlineCustomButton>
                )}
                <OutlineCustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  onClick={() => setFilterOpen(true)}
                >
                  Filter
                </OutlineCustomButton>

                <Box
                  display="flex"
                  sx={{
                    border: `1px solid #CBD5E1`,
                    borderRadius: "30px",
                    pl: 1.5,
                    pr: 0.5,
                    height: 40,
                    flexShrink: 0,
                  }}
                  alignItems="center"
                >
                  <Typography fontSize={fontSize.h4.large} noWrap>
                    Settled
                  </Typography>
                  <Switch
                    sx={{
                      "& .MuiSwitch-track": {
                        // backgroundColor: isToggled ? "white" : "#ccc",
                        transition: "background-color 0.3s",
                        borderRadius: 20,
                      },
                      "& .MuiSwitch-thumb": {
                        width: 24,
                        height: 24,
                        backgroundColor: isToggled
                          ? ThemeColor.PURPLE
                          : ThemeColor.BLACK,
                        transition: "transform 0.3s ease",
                        transform: isToggled
                          ? "translateX(2px)"
                          : "translateX(0px)",
                      },
                      "& .MuiSwitch-switchBase": {
                        padding: 1,
                        transition: "transform 0.3s",
                        "&.Mui-checked + .MuiSwitch-track": {
                          backgroundColor: ThemeColor.LIGHTPURPLE,
                        },
                      },
                    }}
                    checked={isToggled ? true : false}
                    onChange={handleStatusChange}
                    color="primary"
                  />
                </Box>
                {!isAgent && (
                  <Box>
                    <CustomButton
                      variant="contained"
                      type="submit"
                      backgroundColor={ThemeColor.PURPLE}
                      color={ThemeColor.WHITE}
                      onClick={handleClick}
                    // onClick={() => handleExport()}
                    >
                      Export
                    </CustomButton>
                    <Menu
                      id="demo-positioned-menu"
                      aria-labelledby="demo-positioned-button"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      PaperProps={{
                        sx: {
                          borderRadius: "12px",
                          boxShadow: "0 12px 30px rgba(0, 0, 0, 0.12)",
                          border: "1px solid #E2E8F0",
                          minWidth: "260px",
                          p: 0.5,
                        },
                      }}
                    >
                      {/* University Actions */}
                      <Box sx={{ px: 2, py: 1, color: "#94A3B8", fontSize: "0.7rem", fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase" }}>
                        University Actions
                      </Box>
                      <Tooltip title={stepHint("Export For University")} placement="left">
                        <MenuItem
                          onClick={() => {
                            handleClose();
                            handleExportForUniv(true, "University-Transaction");
                          }}
                          sx={{ gap: 1.5, py: 1, borderRadius: "6px", fontSize: "0.875rem", color: "#1E293B", "&:hover": { bgcolor: "#F1F5F9" } }}
                        >
                          <CloudDownloadIcon fontSize="small" sx={{ color: ThemeColor.PURPLE }} />
                          Export For University
                        </MenuItem>
                      </Tooltip>
                      <Tooltip title={stepHint("Import University Transaction")} placement="left">
                        <MenuItem
                          onClick={() => {
                            handleClose();
                            handleCloseFilterExcelModal();
                          }}
                          sx={{ gap: 1.5, py: 1, borderRadius: "6px", fontSize: "0.875rem", color: "#1E293B", "&:hover": { bgcolor: "#F1F5F9" } }}
                        >
                          <CloudUploadIcon fontSize="small" sx={{ color: "green" }} />
                          Import University Transaction
                        </MenuItem>
                      </Tooltip>
                      <Tooltip title={stepHint("Export For University Invoice")} placement="left">
                        <MenuItem
                          onClick={() => {
                            handleClose();
                            handleExportForUniv(true, "University-Invoice");
                          }}
                          sx={{ gap: 1.5, py: 1, borderRadius: "6px", fontSize: "0.875rem", color: "#1E293B", "&:hover": { bgcolor: "#F1F5F9" } }}
                        >
                          <CloudDownloadIcon fontSize="small" sx={{ color: ThemeColor.PURPLE }} />
                          Export For University Invoice
                        </MenuItem>
                      </Tooltip>
                      <Tooltip title={stepHint("Import Credited Amount")} placement="left">
                        <MenuItem
                          onClick={() => {
                            handleClose();
                            handleCloseIsCreditedModal();
                          }}
                          sx={{ gap: 1.5, py: 1, borderRadius: "6px", fontSize: "0.875rem", color: "#1E293B", "&:hover": { bgcolor: "#F1F5F9" } }}
                        >
                          <CloudUploadIcon fontSize="small" sx={{ color: "green" }} />
                          Import Credited Amount
                        </MenuItem>
                      </Tooltip>

                      <Divider sx={{ my: 1 }} />

                      {/* Organisation Actions */}
                      <Box sx={{ px: 2, py: 1, color: "#94A3B8", fontSize: "0.7rem", fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase" }}>
                        Organisation Actions
                      </Box>
                      <Tooltip title={stepHint("Export For Organisation")} placement="left">
                        <MenuItem
                          onClick={() => {
                            handleClose();
                            // No row selection: an organisation is owed an
                            // account of every student it has for an intake.
                            setOrgExportOpen(true);
                          }}
                          sx={{ gap: 1.5, py: 1, borderRadius: "6px", fontSize: "0.875rem", color: "#1E293B", "&:hover": { bgcolor: "#F1F5F9" } }}
                        >
                          <CloudDownloadIcon fontSize="small" sx={{ color: ThemeColor.PURPLE }} />
                          Export For Organisation
                        </MenuItem>
                      </Tooltip>
                      <Tooltip title={stepHint("Export For Organisation Invoice")} placement="left">
                        <MenuItem
                          onClick={() => {
                            handleClose();
                            setInvoiceExportOpen(true);
                          }}
                          sx={{ gap: 1.5, py: 1, borderRadius: "6px", fontSize: "0.875rem", color: "#1E293B", "&:hover": { bgcolor: "#F1F5F9" } }}
                        >
                          <CloudDownloadIcon fontSize="small" sx={{ color: ThemeColor.PURPLE }} />
                          Export For Organisation Invoice
                        </MenuItem>
                      </Tooltip>
                      <Tooltip title={stepHint("Import Settled Amount")} placement="left">
                        <MenuItem
                          onClick={() => {
                            handleClose();
                            handleCloseIsSettledModal();
                          }}
                          sx={{ gap: 1.5, py: 1, borderRadius: "6px", fontSize: "0.875rem", color: "#1E293B", "&:hover": { bgcolor: "#F1F5F9" } }}
                        >
                          <CloudUploadIcon fontSize="small" sx={{ color: "green" }} />
                          Import Settled Amount
                        </MenuItem>
                      </Tooltip>
                    </Menu>
                  </Box>
                )}

                {/* <div>
              <Settinglist fill={ThemeColor.GREY} />
            </div> */}
              </Box>
            </Grid>
          </Grid>
          <div className="table-container mt-4" style={{ overflowX: "scroll" }}>
            <CustomDataTable
              row={
                unsettledListlist
                  ? unsettledListlist.filter((data) => {
                    const isRecentIntake = checkYearOfIntake(data);

                    // If intake year is recent, keep all entries
                    // Otherwise, filter out only if commissionStatus is "not_approved"
                    return (
                      isRecentIntake ||
                      data.commissionStatus !== "not_approved"
                    );
                  })
                  : []
              }
              columns={columns}
              loading={table_load}
              rowheight={50}
              onSelectionChange={(newSelection) => {
                //(newSelection, "new selection");
                // setTable_load(true)
                setSelectionModel(newSelection);
              }}
              getRowClassName={(params) => params.row.isActive}
            />
          </div>

          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            limit={limit}
            onLimitChange={handleLimitChange}
          />

          {/* modal for all reminder window */}
          <OrganisationExportModal
        open={invoiceExportOpen}
        onClose={() => setInvoiceExportOpen(false)}
        onExport={handleExport}
        organisations={Organizationlist || []}
        universities={Universitylist || []}
        intakes={intakeOptions}
        loading={invoiceExportLoading}
        title="Export For Organisation Invoice"
        description="Only instalments the university has already paid and that are not settled yet can be invoiced."
      />
      <OrganisationExportModal
        open={orgExportOpen}
        onClose={() => setOrgExportOpen(false)}
        onExport={handleOrganisationExport}
        organisations={Organizationlist || []}
        universities={Universitylist || []}
        intakes={intakeOptions}
        loading={orgExportLoading}
        showApprovedOnly
        requireIntake
        description="Everyone from the chosen intake, plus any student whose payment is still open - a cycle runs across semesters, so an earlier intake's second or third payment belongs in this statement too. Approved, not approved, pending and deferred alike."
      />
      <PayoutWorkflowModal
            open={workflowHelpOpen}
            onClose={() => setWorkflowHelpOpen(false)}
          />
          <PayoutAllReminderModal
            HistoryModal={HistoryModal}
            handleClose={handleCloseHistoryModal}
            AgentTransactionlist={AgentTransactionlist}
            isAgent={isAgent}
          />

          <ConfirmationModal
            handleConfirmationClose={() => {
              setConfirmationOpen(false);
            }}
            deletefunction={async () => {
              if (TypeOfdelete === "notes") {
                try {
                  const res = await DeleteStudentNotesService({
                    stdId,
                    noteId,
                  });

                  if (res.status === 200) {
                    dispatch(GetStudentNotesByIdAction(stdId)); // Dispatch the action if success
                    return res; // Return the result so the child can access it
                  } else {
                    return Promise.reject("Unexpected response status"); // Handle unexpected status codes
                  }
                } catch (e) {
                  dispatch(
                    showSnackbar(
                      e.response?.data?.message || "Error occurred",
                      "error"
                    )
                  );
                  return e; // Return the error to the child if needed
                }
              } else {
                try {
                  const res = await DeleteStudentReminderService({
                    reminderId,
                  });

                  if (res.status === 200) {
                    dispatch(GetStudentReminderByIdAction(stdId)); // Dispatch the action if success
                    return res; // Return the result so the child can access it
                  } else {
                    return Promise.reject("Unexpected response status"); // Handle unexpected status codes
                  }
                } catch (e) {
                  dispatch(
                    showSnackbar(
                      e.response?.data?.message || "Error occurred",
                      "error"
                    )
                  );
                  return e; // Return the error to the child if needed
                }
              }
            }}
            confirmationopen={confirmationopen}
            message={
              TypeOfdelete === "notes"
                ? "All deleted notes is never been retrievable"
                : "All deleted reminder is never been retrievable"
            }
          />

          <FilterComponent
            open={isFilterOpen}
            onClose={() => setFilterOpen(false)}
            onApply={handleApplyFilters}
            initialFilters={activeFilters}
            fields={fields}
            // This list ranges over when the visa was approved, not when the
            // student was entered.
            dateLabel="Visa Approved Date"
          />

          <DefaultCommissionModal
            open={defaultCommisionModal}
            onClose={handleDefaultCommissionModal}
          />

          <FilterExcelUniversity
            open={FilterExcelModal}
            onClose={handleCloseFilterExcelModal}
          />

          <UpdateBulkIsCredited
            open={BulkIsCreditedModal}
            onClose={handleCloseIsCreditedModal}
          />

          <UpdateBulkIsSettled
            open={BulkIsSetteledModal}
            onClose={handleCloseIsSettledModal}
          />
        </>
      )}
    </div>
  );
};

function Payoutlist() {
  return (
    <div>
      <ResponsiveDrawer maincontent={<PayoutlistPage />} />
    </div>
  );
}

export default Payoutlist;
